<template>
    <div>
        <Hero></Hero>
      <DestinationIntegrations></DestinationIntegrations>
      <SchemaDrift></SchemaDrift>
      <AwsGlue></AwsGlue>
    </div>
</template>

<script>

    import Hero from './sections/home/Hero.vue'
    import AwsGlue from './sections/home/AwsGlue.vue'
    // import GettingStarted from './sections/home/GettingStarted.vue'
    // import SourceIntegrations from './sections/home/SourceIntegrations.vue'
    import DestinationIntegrations from './sections/home/DestinationIntegrations.vue'
    // import RealTime from './sections/home/RealTime.vue'
    import SchemaDrift from './sections/home/SchemaDrift.vue'
    // import PipelinesUi from './sections/home/PipelinesUi.vue'

    export default {
        name: 'Home',
        components: {
            Hero,
            AwsGlue,
            // GettingStarted,
            // SourceIntegrations,
            DestinationIntegrations,
            // RealTime,
            SchemaDrift,
            // PipelinesUi,
        },
        props: {
            msg: String
        },
        head: {
            title: {
                inner: 'Skippr',
                separator: '-',
                complement: 'Any Data Source, Any Cloud Datalake'
            },
            //omited
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
